/**
 * EAA-1762: OIDC runtime config for web-content — sourced from the same Vite
 * env mechanism as `VITE_AI_API_URL` (see `.env.localdev`/`.env.dev`/...),
 * NOT a fetched `/config.json` like apps/portal (web-content has no runtime-
 * config bootstrap; env-at-build-time is its existing pattern, so we reuse
 * it instead of introducing a second config mechanism). Falls back to the
 * shared local Keycloak realm so `pnpm dev` works out of the box.
 */
export interface EmgAuthRuntimeConfig {
    authority: string;
    clientId: string;
    /**
     * EAA-1762 addendum: environments with no deployed Keycloak/portal (UAT) can't use the
     * default OIDC flow at all — 'password' switches web-content back onto the
     * username/password path that's still live on the backend (POST /auth/login),
     * bypassing Keycloak and the portal bounce entirely. See auth.service.ts and
     * authOperations.ts for what branches on this.
     */
    mode: 'oidc' | 'password';
}

export const authConfig: EmgAuthRuntimeConfig = {
    authority: import.meta.env.VITE_OIDC_AUTHORITY || 'http://localhost:8081/realms/emg',
    clientId: import.meta.env.VITE_OIDC_CLIENT_ID || 'web-content',
    mode: import.meta.env.VITE_AUTH_MODE === 'password' ? 'password' : 'oidc',
};
